//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { InstagramPostDetailsModalActions } from '@instagram-account/redux/post-details/modal/instagramPostDetailsModalActions';
import {
  IInstagramPostDetailsModalState,
  INSTAGRAM_POST_DETAILS_MODAL_ACTIONS,
} from '@instagram-account/redux/post-details/modal/instagramPostDetailsModalModel';

const initialState: IInstagramPostDetailsModalState = {
  isDefaultsModalOpen: false,
  isRemoveFieldsModalOpen: false,
  isVideoThumbnailModalOpen: false,
  isCancelChangesModalOpen: false,
  isSwapScheduledToDraftModalOpen: false,
  isAddMediaModalOpen: false,
};

export default function InstagramPostDetailsModalReducer(
  state: IInstagramPostDetailsModalState = initialState,
  action: InstagramPostDetailsModalActions,
): IInstagramPostDetailsModalState {
  switch (action.type) {
    case INSTAGRAM_POST_DETAILS_MODAL_ACTIONS.TOGGLE_REMOVE_FIELDS_MODAL: {
      return {
        ...state,
        isRemoveFieldsModalOpen: !state.isRemoveFieldsModalOpen,
      };
    }
    case INSTAGRAM_POST_DETAILS_MODAL_ACTIONS.TOGGLE_DEFAULTS_MODAL: {
      return {
        ...state,
        isDefaultsModalOpen: !state.isDefaultsModalOpen,
      };
    }
    case INSTAGRAM_POST_DETAILS_MODAL_ACTIONS.TOGGLE_VIDEO_THUMBNAIL_MODAL: {
      return {
        ...state,
        isVideoThumbnailModalOpen: !state.isVideoThumbnailModalOpen,
      };
    }
    case INSTAGRAM_POST_DETAILS_MODAL_ACTIONS.TOGGLE_CANCEL_CHANGES_MODAL: {
      return {
        ...state,
        isCancelChangesModalOpen: !state.isCancelChangesModalOpen,
      };
    }
    case INSTAGRAM_POST_DETAILS_MODAL_ACTIONS.TOGGLE_SWAP_SCHEDULED_TO_DRAFT_MODAL: {
      return {
        ...state,
        isSwapScheduledToDraftModalOpen: !state.isSwapScheduledToDraftModalOpen,
      };
    }
    case INSTAGRAM_POST_DETAILS_MODAL_ACTIONS.TOGGLE_ADD_MEDIA_MODAL: {
      return {
        ...state,
        isAddMediaModalOpen: !state.isAddMediaModalOpen,
      };
    }
  }
  return state;
}
